// @ts-nocheck

import { colors } from '@lmc/common/constants'
import {
  EMAR_STOCK_SUMMARY_ITEM_ID,
  ITEM_ID_SHORT_SEIZURE
} from '@lmc/common/types'
import { Chevron, Collapse, Panel } from '@lmc/ui-kit'
import { Switch } from 'antd'
import _, { chain, filter, find, includes } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { DotIconSection } from '../../generic'
import DotIcon from '../../generic/DotIcon/DotIcon'

export class LogCategoryItemField extends React.Component {
  state = {}

  toggleItem = (itemId) => {
    // push or pull from array
    const { values, formKey } = this.props
    const prev = values[formKey] || []
    if (includes(prev, itemId)) {
      this.props.onChange({
        key: formKey,
        value: filter(prev, (i) => i !== itemId)
      })
    } else {
      // push
      this.props.onChange({
        key: formKey,
        value: [...prev, itemId]
      })
    }
  }

  filterItems = (items, selectedCategory, hideShortSeizure) => {
    return chain(items)
      .filter(
        (item) =>
          item.category === selectedCategory &&
          (hideShortSeizure ? item?.id !== ITEM_ID_SHORT_SEIZURE : true) &&
          item?.itemId !== EMAR_STOCK_SUMMARY_ITEM_ID
      )
      .orderBy('name')
      .value()
  }

  renderCategoryItems = (category) => {
    const { values, formKey, hideShortSeizure } = this.props

    const items = this.filterItems(
      this.props.items,
      category.id,
      hideShortSeizure
    )

    if (!items) return null

    const isActive = (itemId) => includes(values[formKey], itemId)

    return (
      <CategoryItemsContainer>
        {items.map((item) => (
          <ItemRow key={item.id}>
            <IconContainer>
              <DotIcon
                color={
                  isActive(item.id) ? item.color || category.color : colors.grey
                }
                url={item.icon}
              />
            </IconContainer>
            <ContentContainer>
              <ItemName isActive={isActive(item.id)}>{item.name}</ItemName>
              <ItemNote isActive={isActive(item.id)}>{item.note}</ItemNote>
            </ContentContainer>
            <SwitchContainer>
              <Switch
                onChange={() => this.toggleItem(item.id)}
                checked={isActive(item.id)}
              />
            </SwitchContainer>
          </ItemRow>
        ))}
      </CategoryItemsContainer>
    )
  }

  render() {
    const { formKey, categories, items } = this.props

    const isFamilyLogSettings = formKey === 'familyLogCategoryItems'

    if (!categories || !items) return null
    return (
      <div>
        <LabelContainer>
          <Label isFamilyLogSettings={isFamilyLogSettings}>
            {isFamilyLogSettings ? 'Show in Family Portal' : 'Show in App'}
          </Label>
        </LabelContainer>
        <StyledCollapse
          expandIconPosition="end"
          expandIcon={(opt) => {
            return opt.isActive ? (
              <Chevron direction="down" />
            ) : (
              <Chevron direction="right" />
            )
          }}
        >
          {categories.map((category) => (
            <Panel
              key={category.id}
              header={
                <DotIconSection
                  text={category.name}
                  iconUrl={category.icon}
                  iconColor={category.color}
                />
              }
            >
              {this.renderCategoryItems(category)}
            </Panel>
          ))}
        </StyledCollapse>
      </div>
    )
  }
}

const StyledCollapse = styled(Collapse)`
  &&.ant-collapse.ant-collapse-icon-position-start,  &&.ant-collapse.ant-collapse-icon-position-end {
  border-color: ${(props) => props.theme.color.neutral.color8};

  .ant-collapse-item, .ant-collapse-header, .ant-collapse-content {
    border-color: ${(props) => props.theme.color.neutral.color8};
  }

  .ant-collapse-header {
    padding: 8px 16px;
  }
   
  .ant-collapse-header-text{
    li {padding-left: 0px !important;}
  }

  .ant-collapse-item {
    .ant-collapse-header {
      align-items: baseline;
    }
  }
`

const CategoryItemsContainer = styled.div`
  padding-left: 16px;
  width: 100%;
  margin-bottom: 25px;
`

const ItemRow = styled.div`
  padding-top: 8px;
  padding-bottom: 10px;
  display: flex;
`

const IconContainer = styled.div`
  flex: 1;
  max-width: 40px;
`

const ContentContainer = styled.div`
  flex: 10;
  margin-top: 6px;
  padding-left: 16px;
`

const ItemName = styled.div<{ isActive: boolean }>`
  color: ${(props) => (props.isActive ? 'black' : colors.grey)};
  font-size: 18px;
  font-weight: bold;
`

const ItemNote = styled.div<{ isActive: boolean }>`
  color: ${(props) => (props.isActive ? 'black' : colors.grey)};
`

const SwitchContainer = styled.div`
  flex: 0;
  margin: 8px 0px 0 40px;
`

const LabelContainer = styled.p`
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 6px;
  display: flex;
  justify-content: flex-end;
`

const Label = styled.div<{ isFamilyLogSettings: boolean }>`
  margin-right: ${(props) => (props.isFamilyLogSettings ? 5 : 33)}px;
`

const mapStateToProps = (state, props) => {
  return {
    categories: chain(state.data['log-categories'])
      .orderBy('name')
      .filter(({ itemId }) => itemId !== 'bodyMaps')
      .value(),
    items: _.filter(state.data['log-category-items'], { visible: true })
  }
}

export default connect(mapStateToProps, null)(LogCategoryItemField)
